module.exports = __webpack_public_path__ + "img/prizinig.dd2c4dfe.png";